const videoBlock = {
  $blocks: document.querySelectorAll('section.tjh_video'),
  init() {
    if (this.$blocks.length) {
      this.setUpListeners();
      this.initLoopPreviews();
    }
  },

  getActiveVideo($block) {
    const hasPortrait = $block.classList.contains('with_portrait');

    if (hasPortrait && window.innerWidth <= 768) {
      return $block.querySelector('.video.portrait video');
    }

    return $block.querySelector('.video.landscape video');
  },

  initLoopPreviews() {
    this.$blocks.forEach($block => {
      if (!$block.classList.contains('with_loop_preview')) {
        return;
      }

      const $video = this.getActiveVideo($block);

      if (!$video || !$video.dataset.loopSrc) {
        return;
      }

      const playLoop = () => {
        $video.play().catch(() => {});
      };

      if ($video.readyState >= 2) {
        playLoop();
      } else {
        $video.addEventListener('loadeddata', playLoop, {once: true});
      }
    });
  },

  setUpListeners() {
    this.$blocks
      .forEach($block => {
        const template = $block.classList.contains('template_advanced') ? 'advanced' : 'static';

        if (template === 'advanced' && window.innerWidth > 768) {
          $block.addEventListener('mousemove', this.mouseMoveHandler.bind(this));
          $block.addEventListener('mouseleave', this.mouseLeaveHandler.bind(this));
        }

        $block.addEventListener('click', this.initializeVideo.bind(this), {
          once: true
        });
      });
  },

  setMuted($video, muted, player = null) {
    $video.defaultMuted = muted;
    $video.muted = muted;

    if (muted) {
      $video.setAttribute('muted', '');
    } else {
      $video.removeAttribute('muted');

      if (player && typeof player.unMute === 'function') {
        player.unMute();
      }
    }
  },

  prepareFullVideo($video, muted, loop) {
    $video.pause();
    $video.removeAttribute('autoplay');
    $video.removeAttribute('loop');
    $video.loop = loop;
    $video.controls = $video.dataset.fullControls === '1';
    $video.autoplay = false;
    $video.currentTime = 0;
    this.setMuted($video, muted);
    $video.src = $video.dataset.src;
    $video.load();
  },

  playVideo($video, muted, player = null) {
    const tryPlay = () => {
      this.setMuted($video, muted, player);

      if (player) {
        player.play();
      } else {
        $video.play().catch(() => {});
      }

      window.requestAnimationFrame(() => this.setMuted($video, muted, player));
    };

    tryPlay();

    if ($video.paused) {
      $video.addEventListener('canplay', tryPlay, {once: true});
    }
  },

  initializeVideo(ev) {
    const $block = ev.currentTarget;
    const hadLoopPreview = $block.classList.contains('with_loop_preview');
    const $activeVideo = this.getActiveVideo($block);

    $block.classList.remove('with_loop_preview', 'init');

    if (!$activeVideo) {
      return;
    }

    $block.querySelectorAll('video').forEach($video => {
      const isActive = $video === $activeVideo;
      const muted = !hadLoopPreview && $video.dataset.fullMuted === '1';
      const loop = !hadLoopPreview && $video.dataset.fullLoop === '1';

      this.prepareFullVideo($video, muted, loop);

      if (isActive) {
        this.playVideo($video, muted);
      }

      new Vlitejs($video, {
        options: {
          poster: window.innerWidth <= 768 ? $video.dataset.portraitPoster : $video.dataset.landscapePoster,
          autoplay: false,
          bigPlay: false,
          controls: $video.dataset.fullControls === '1',
          loop: loop,
          muted: muted
        },
        onReady: (player) => {
          player.on('play', () => {
            if (this.getActiveVideo($block) !== $video) {
              return;
            }

            $block.classList.add('playing');
            $block.classList.remove('paused');
          });

          player.on('pause', () => {
            if (this.getActiveVideo($block) !== $video) {
              return;
            }

            $block.classList.add('paused');
            $block.classList.remove('playing');
          });

          if (isActive) {
            this.playVideo($video, muted, player);
          }
        }
      });
    });
  },

  mouseMoveHandler({clientX, clientY, currentTarget}) {
    const wrapperRect = currentTarget.getBoundingClientRect();
    const $btn = currentTarget.querySelector('.follower');
    let newX = (clientX - wrapperRect.x) / wrapperRect.width;
    let newY = (clientY - wrapperRect.y) / wrapperRect.height;
    newX -= 0.5;
    newY -= 0.5;
    newX *= wrapperRect.width;
    newY *= wrapperRect.height;

    if ($btn) {
      gsap.to($btn, {
        x: newX,
        y: newY,
        duration: 2,
        ease: 'expo.out'
      });
    }
  },

  mouseLeaveHandler({currentTarget}) {
    const $btn = currentTarget.querySelector('.follower');

    if ($btn) {
      gsap.to($btn, {
        x: 0,
        y: 0,
        duration: 2,
        ease: 'expo.out'
      });
    }
  }
};

videoBlock.init();
